/**
 * FAQ Section — Uses shadcn Accordion. Pure presentation.
 */
import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

const FAQSection = ({ faqs }) => (
  <section className="section section-dark" id="faq" data-testid="faq-section">
    <div className="section-header">
      <h2 className="section-title">Preguntas Frecuentes</h2>
      <p className="section-subtitle">
        Las mismas dudas que has usado como excusa para no empezar 🤷‍♂️
      </p>
    </div>
    <div className="faq-container">
      <Accordion type="single" collapsible className="w-full">
        {faqs.map((faq) => (
          <AccordionItem key={faq.id} value={`item-${faq.id}`} className="faq-item">
            <AccordionTrigger className="faq-question">{faq.question}</AccordionTrigger>
            <AccordionContent className="faq-answer">{faq.answer}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

export default FAQSection;
